<template>
  <!-- 注意力训练营-->
  <div class="shehuigongnengkaifake">
    <CertQuery :logo="Logo23" :type="'zylxly'" :color="'#294db0'" />
  </div>
</template>

<script>
import CertQuery from '../component/certQuery.vue'
import Logo23 from '@/assets/images/logo23.jpg'

export default {
  name: 'SheHuiGongNengKaiFa',
  components: {
    CertQuery
  },
  data() {
    return {
      Logo23
    }
  }
}
</script>